import { IPushbackConfiguration } from "../../models/configuration/pushback/IConfiguration";

import { Action, ActionType } from "../actions";

interface DefaultValueState {
  loading: boolean;
  error: string | null;
  data: IPushbackConfiguration | null;
  persistedData: IPushbackConfiguration | null;
}

const initialState = { loading: false, error: null, data: null, persistedData: null };

const clonePushbackConfig = (payload: IPushbackConfiguration | null): IPushbackConfiguration | null => {
  if (!payload) return payload;
  return JSON.parse(JSON.stringify(payload)) as IPushbackConfiguration;
};

const configDefaultValueReducer = (
  state: DefaultValueState = initialState,
  action: Action
): DefaultValueState => {
  switch (action.type) {
    // GET DATA
    case ActionType.GET_CONFIG_PUSHBACK:
      return { loading: true, error: null, data: null, persistedData: state.persistedData };
    case ActionType.GET_CONFIG_PUSHBACK_FAILURE:
      return { loading: false, error: action.payload, data: null, persistedData: state.persistedData };
    case ActionType.GET_CONFIG_PUSHBACK_SUCCESS: {
      const persistedData = action.fromServer
        ? clonePushbackConfig(action.payload)
        : state.persistedData;
      return { loading: false, error: null, data: action.payload, persistedData };
    }
    case ActionType.SET_CONFIG_PUSHBACK_LOCAL:
      return { ...state, data: action.payload };

    // SAVE DATA
    case ActionType.SAVE_CONFIG_PUSHBACK:
      return { ...state, loading: true, error: null, data: state.data };
    case ActionType.SAVE_CONFIG_PUSHBACK_FAILURE:
      return { loading: false, error: action.payload, data: state.data, persistedData: state.persistedData };
    case ActionType.SAVE_CONFIG_PUSHBACK_SUCCESS:
      return { loading: false, error: null, data: action.payload, persistedData: clonePushbackConfig(action.payload) };
    case ActionType.CONFIG_ID_CHANGED:
      return initialState;
    default:
      return state;
  }
};

export default configDefaultValueReducer;